import React from 'react';
import PropTypes from 'prop-types';
import glamorous from 'glamorous';

import TaraAvatar from './TaraAvatar';
import TaraText from './TaraText';

const Row = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
});

class TaraHeader extends React.PureComponent {
  static propTypes = {
    isAnimated: PropTypes.bool,
    message: PropTypes.node,
  };

  static defaultProps = {
    isAnimated: false,
    message: undefined,
  };

  state = {
    isChangingMessage: false,
  };

  currentMessage = this.props.message;

  componentDidMount() {
    this.hasMounted = true;
  }

  componentWillUnmount() {
    this.hasMounted = false;
  }

  componentWillReceiveProps(nextProps) {
    const { message } = nextProps;

    if (message !== this.props.message) {
      this.currentMessage = this.props.message;
      this.setIsChangingMessage();
    }
  }

  setIsChangingMessage = () => {
    if (!this.state.isChangingMessage) {
      this.setState({
        isChangingMessage: true,
      });

      setTimeout(() => {
        if (this.hasMounted) {
          this.currentMessage = this.props.message;
          this.setState({
            isChangingMessage: false,
          });
        }
      }, 800);
    }
  };

  renderAnimatedText() {
    const {
      textStyle,
    } = this.props;

    const {
      isChangingMessage,
    } = this.state;

    return (
      <div className={isChangingMessage ? 'TaraText--scaleOut' : 'TaraText--scaleIn'}>
        <TaraText
          isAnimated={false}
          style={textStyle}
        >
          {this.currentMessage}
        </TaraText>
      </div>
    );
  }

  renderText() {
    return (
      <TaraText
        isAnimated={false}
        style={this.props.textStyle}
      >
        {this.currentMessage}
      </TaraText>
    )
  }

  render() {
    const {
      isAnimated,
      style,
    } = this.props;

    return (
      <Row style={style}>
        <TaraAvatar className={isAnimated ? 'animated bounceIn' : undefined} />
        {isAnimated ? this.renderAnimatedText() : this.renderText()}
      </Row>
    );
  }
}

export default TaraHeader;



// WEBPACK FOOTER //
// ./src/components/features/Tara/TaraHeader.js